import { TEST , FETCH_USER_DATA } from "../type";


const initialState = {
};

const generalReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TEST : 
    return {
      ...state,
    };
    case FETCH_USER_DATA : 
    return {
      ...state,
      userData: action.payload,
    };
  default:
    return state;
  }
};

export default generalReducer;
